import React from 'react'
import PropTypes from 'prop-types'
import { Colours, Sizes } from '../../style_helpers'

const PencilIcon = (props) => {
  return (
    <svg height={props.height} style={props.style} viewBox='0 0 21 21' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' strokeLinecap='round' strokeLinejoin='round'>
        <g transform='translate(-870.000000, -2488.000000)' stroke={props.colour} strokeWidth={props.lineWeight}>
          <g transform='translate(750.000000, 2285.000000)'>
            <g transform='translate(45.041152, 122.000000)'>
              <g transform='translate(55.113169, 62.000000)'>
                <g transform='translate(21.043210, 19.000000)'>
                  <polygon points='13.213754 0.985834424 18.708683 6.46590542 5.75577773 19.6436637 0.000267263082 19.6436637 0.000267263082 13.9023831' />
                  <path d='M9.54997806,4.6390374 L15.044907,10.1191084' />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

PencilIcon.propTypes = {
  height: PropTypes.string,
  style: PropTypes.object,
  colour: PropTypes.string,
  lineWeight: PropTypes.number
}

PencilIcon.defaultProps = {
  height: Sizes(0),
  colour: Colours('grey', '500'),
  lineWeight: 1
}

export default PencilIcon
